import styled from 'styled-components';
import Cell from './Cell';
import Row from './Row';

export default styled.thead`
  border-bottom: solid 1px #e1dfdf;
  background-color: #F4F5F7;

  ${Row} {
    &:first-child {
      ${Cell} {
        &:first-child {
          border-top-left-radius: 4px;
        }

        &:last-child {
          border-top-right-radius: 4px;
        }
      }
    }

    ${Cell} {
      color: #494F5A;
      font-size: 16px;
      line-height: 1.2;
      padding-top: 0.9em;
      padding-bottom: 0.9em;
      background-color: #F4F5F7;
      border-bottom: solid 1px #e1dfdf;
      font-weight: 600;
    }
  }
`;
